import { render, staticRenderFns } from "./ClubEmblem.vue?vue&type=template&id=2db90210"
import script from "./ClubEmblem.vue?vue&type=script&lang=js"
export * from "./ClubEmblem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports